import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TotBatchService } from 'projects/services/src/app/API/tot-batch.service';
import { Location } from '@angular/common';
import { ShareDataService } from 'projects/shared/src/app/shared/share-data.service';
import { OFFLINE_ASSMNT_STATUS } from 'projects/shared/src/app/shared/batch.table';

@Component({
  selector: 'app-aa-audit-trail',
  templateUrl: './aa-audit-trail.component.html',
  styleUrls: ['./aa-audit-trail.component.css']
})
export class AaAuditTrailComponent implements OnInit {
  metaData = {
    batchId: Number,
    qpCode: String,
    version: String,
    actionByRole: String
  }
  sscAuditTrial: any;
  aaAuditTrial: any;
  arAuditTrial: any;
  prAuditTrial: any;
  batchData: any;
  constructor(
    private activateRoute: ActivatedRoute,
    private totToaService: TotBatchService,
    private sharedService: ShareDataService,
    private location: Location
  ) {
    this.sharedService.getBatchData().subscribe(res => {
      this.batchData = res;
    })
  }

  ngOnInit() {
    const isBatchAvail = this.batchData && this.batchData.batchId || ''
    if (isBatchAvail === '') {
      this.goBack();
    }
    this.activateRoute.params.subscribe(res => {
      this.metaData.batchId = res && res.batchId;
      this.metaData.qpCode = res && res.qpCode;
      this.metaData.version = res && res.version;
      this.metaData.actionByRole = res && res.actionByRole;
      this.getAuditTrials('Assessor');
      this.getAuditTrials('Assessment Agency');
      this.getAuditTrials('SSC');
      this.getAuditTrials('Proctor');
    })
  }

  getAuditTrials(role) {
    this.totToaService.getAuditTrails(this.metaData.batchId, this.metaData.qpCode, this.metaData.version, role).subscribe(res => {
      console.log(res);
      if (role === 'SSC') {
        this.sscAuditTrial = res && res.result && res.result[0] && res.result[0].offlineAssessmentDetails || [];

      } else if (role === 'Assessment Agency') {
        this.aaAuditTrial = res && res.result && res.result[0] && res.result[0].offlineAssessmentDetails || [];
      } else if (role === 'Assessor') {
        this.arAuditTrial = res && res.result && res.result[0] && res.result[0].offlineAssessmentDetails || [];
      } else if (role === 'Proctor') {
        this.prAuditTrial = res && res.result && res.result[0] && res.result[0].offlineAssessmentDetails || [];
      }
      console.log(this.sscAuditTrial);
      console.log(this.aaAuditTrial);
      console.log(this.arAuditTrial);
      console.log(this.prAuditTrial);

    })
  }

  goBack() {
    this.location.back();
  }

  displayStatus(status) {
    let batchStatus;
    switch (status) {
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_INITIAL.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_INITIAL.display;
        break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AR_PENDING.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AR_PENDING.display;
        break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AR_SUBMITTED.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AR_SUBMITTED.display;
      break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_APPROVED.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_APPROVED.display;
      break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_SENT_BACK.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_SENT_BACK.display;
      break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_REJECTED.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_REJECTED.display;
      break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_SSC_APPROVED.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_SSC_APPROVED.display;
      break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_SSC_SENT_BACK.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_SSC_SENT_BACK.display;
        break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_SSC_REJECTED.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_SSC_REJECTED.display;
        break;
      case OFFLINE_ASSMNT_STATUS.	OFFLINE_ASSMT_PR_PENDING.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_PR_PENDING.display;
        break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_PR_SUBMITTED.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_PR_SUBMITTED.display;
        break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_INITIAL.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_INITIAL.display;
        break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_PENDING.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_PENDING.display;
        break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_SUBMITTED.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_AA_SUBMITTED.display;
        break;
      case OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_PR_INITIAL.value:
        batchStatus = OFFLINE_ASSMNT_STATUS.OFFLINE_ASSMT_PR_INITIAL.display;
        break;
      default:
        batchStatus = 'N/A'


    }
    return batchStatus;
  }

}
